export default __webpack_public_path__ + "static/media/calendarWatch.ba4a8b50.svg";